import { BleManager } from 'react-native-ble-plx';

export class BleSingletonManager {
  public static getBleManagerInstance() {
    if (!this.bleManager) {
      this.bleManager = new BleManager();
    }
    return this.bleManager;
  }

  private static bleManager: BleManager | null = null;
}
